import { render, staticRenderFns } from "./bidding-list.vue?vue&type=template&id=afab7db6"
import script from "./bidding-list.vue?vue&type=script&lang=js"
export * from "./bidding-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports